import { ClerkProvider } from '@clerk/clerk-react'
import { createStore } from '@saaga/shared/store/store'
import type { ReactNode } from 'react'
import { Provider as ReduxProvider } from 'react-redux'
import { RouterProvider } from 'react-router-dom'

import { APP_BASE_PATH } from './app.const'
import { rootRoutes } from './routes/org-routes.const'
import './components/split-view/split-view.registrations'
import { Toaster } from './components/ui/sonner'
import { useAuthSync } from './hooks/use-auth-sync.hook'
import { useIntercom } from './hooks/use-intercom.hook'
import { useOrganizationReset } from './hooks/use-organization-reset.hook'
import { router } from './routes/router'

const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

if (!CLERK_PUBLISHABLE_KEY) {
  throw new Error('Missing VITE_CLERK_PUBLISHABLE_KEY environment variable')
}

const store = createStore()

const AuthSyncWrapper = ({ children }: { children: ReactNode }): ReactNode => {
  useAuthSync()
  useOrganizationReset()
  useIntercom()
  return <>{children}</>
}

export const App = (): ReactNode => (
  <ReduxProvider store={store}>
    <ClerkProvider
      publishableKey={CLERK_PUBLISHABLE_KEY}
      afterSignOutUrl={`${APP_BASE_PATH}/${rootRoutes.signIn}`}
      signInFallbackRedirectUrl={`${APP_BASE_PATH}/`}
      signUpFallbackRedirectUrl={`${APP_BASE_PATH}/`}
    >
      <AuthSyncWrapper>
        <RouterProvider router={router} />
        <Toaster position="top-right" richColors closeButton />
      </AuthSyncWrapper>
    </ClerkProvider>
  </ReduxProvider>
)
